<template>
    <div>

        <div class="row">
          <div class="col-3">

            <DatePicker type="daterange" v-model="filterDate" placeholder="Pickup Date" placement="bottom-start"
                        :clearable="false" format="dd/MM/yyyy" class="filterInput" @on-change="onChangeDate"></DatePicker>
          </div>
          <div class="col-3">
            <ApolloQuery class="filterInput" :query="query_SEARCH_CITY" :variables="{cityFilter: dealerCityFilter}"
                         :debounce="500" :skip="skip.dealerSkip">
              <template slot-scope="{ result: { loading, error, data } }">
                <div v-if="loading"> Loading...</div>
                <div v-else-if="error"> Error Occured. {{error}}</div>
                <div v-else>
                  <AutoComplete placeholder="Order City" v-model="dealerCity" :clearable="true" element-id="clientCity"
                                @on-clear="onClearCity('clientCity')" @on-search="onSearchCity($event, 'clientCity')">
                    <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                      <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'clientCity')">{{cityObj.city}}</div>
                    </Option>
                  </AutoComplete>
                </div>
              </template>
            </ApolloQuery>
          </div>
          <div class="col-3">
            <ApolloQuery class="filterInput" :query="query_SEARCH_CITY" :variables="{cityFilter: pickupCityFilter}"
                         :debounce="500" :skip="skip.pickupSkip">
              <template slot-scope="{ result: { loading, error, data } }">
                <div v-if="loading"> Loading...</div>
                <div v-else-if="error"> Error Occured. {{error}}</div>
                <div v-else>
                  <AutoComplete placeholder="Pickup City" v-model="pickupCity" :clearable="true" element-id="pickupCity"
                                @on-clear="onClearCity('pickupCity')" @on-search="onSearchCity($event, 'pickupCity')">
                    <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                      <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'pickupCity')">{{cityObj.city}}</div>
                    </Option>
                  </AutoComplete>
                </div>
              </template>
            </ApolloQuery>
          </div>
          <div class="col-3">
            <ApolloQuery class="filterInput" :query="query_SEARCH_CITY" :variables="{cityFilter: droppingCityFilter}"
                         :debounce="500" :skip="skip.dropSkip">
              <template slot-scope="{ result: { loading, error, data } }">
                <div v-if="loading"> Loading...</div>
                <div v-else-if="error"> Error Occured. {{error}}</div>
                <div v-else>
                  <AutoComplete placeholder="Drop City" v-model="droppingCity" :clearable="true" element-id="dropCity"
                                @on-clear="onClearCity('dropCity')" @on-search="onSearchCity($event, 'dropCity')">
                    <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                      <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'dropCity')">{{cityObj.city}}</div>
                    </Option>
                  </AutoComplete>
                </div>
              </template>
            </ApolloQuery>
          </div>
            <div class="col-3">
                <Input v-model="search" placeholder="Search..." style="width: 300px"/>
            </div>
        </div>


        <Spin fix size="large" v-if="$apollo.queries.orders.loading || $apollo.queries.stages.loading"></Spin>
        <kanban v-else :stages="stages" :blocks="orders">
            <div v-for="stage in stages" :slot="stage.id" :key="stage.id" style="width: 100%">
                <Row type="flex">
                    <h2 style="color: #717372;">{{ stage.name }} </h2>
                    <h2 style="display: inline-block; margin-left: auto; color: #717372;">({{getBlocksLength(stage.id)}})</h2>
                </Row>
            </div>
            <div v-for="order in orders" :slot="order.id" :key="order.id" style="cursor: pointer" @click="editOrder(order)">
                <Card class="cardStyle">
                <Row>
                  <div style="padding: 5px;">
                    <h3 style="font-weight: 400;">#{{ order.orderNumber }}</h3>
                  </div>
                    <!--<Dropdown trigger="hover" style="margin-left: 20px; float: right" :stop-propagation="true">-->
                        <!--<a href="javascript:void(0)" @click.stop="prevent($event)">-->
                            <!--<Icon type="md-more" style="color: black"></Icon>-->
                        <!--</a>-->
                        <!--<DropdownMenu slot="list">-->
                            <!--<DropdownItem>-->
                                <!--<div class="ivu-dropdown-item-div" @click.stop="openOrderDetail(order)">Detail</div>-->
                            <!--</DropdownItem>-->
                            <!--<DropdownItem>-->
                                <!--<div class="ivu-dropdown-item-div" @click.stop="prevent($event)">Delete</div>-->
                                <!--</DropdownItem>-->
                        <!--</DropdownMenu>-->
                    <!--</Dropdown>-->
                    <span class="priorityLabel" :class="'card-label mod-card-front card-label-'+priorityObj[order.priority]">
                        <!--{{priorityObj[order.priority]}}-->
                    </span>
                    <a class="info" @click.stop="openOrderDetail(order)"><i class="fal fa-info-circle"></i></a>
                    <a class="delete" @click.stop="prevent($event)"><i class="fal fa-trash-alt"></i></a>
                </Row>


                <Divider style="margin: 2px 0 0 0;"></Divider>
                <Row>
                    <Col span="24">
                      <div style="display: flex; justify-content: space-between; padding: 5px;">

                          <h3 class="card-left" style="font-weight: 400; font-size: 22px; text-transform: uppercase;">{{order.pickuppartyobject.address[0].city}}</h3>

                        <i class="fas fa-exchange card-center" style="margin-top: auto; margin-bottom: auto;"></i>

                          <h3 class="card-right" style="font-weight: 400; font-size: 22px; text-transform: uppercase; color: #000b15; letter-spacing: 1.5px;">{{order.droppingpartyobject.address[0].city}}</h3>

                      </div>
                    </Col>
                  <Divider style="margin: 2px 0 0 0;"></Divider>
                    <Col span="24">
                      <div style="display: flex; justify-content: space-between; padding: 5px;">
                       <template v-if="order.orderDetails&&order.orderDetails.pickupPoint&&order.orderDetails.pickupPoint.pickupPartyId">
                        <Tooltip :content="order.orderDetails.pickupPoint.pickupPartyName" theme="dark">
                          <h4 class="card-left" style="font-weight: 300; letter-spacing: 1.5px; text-transform: capitalize; ">{{order.orderDetails.pickupPoint.pickupPartyName}}</h4>
                        </Tooltip>
                       </template>
                       <template v-else>
                        <Tooltip :content="order.pickuppartyobject.name" theme="dark">
                          <h4 class="card-left" style="font-weight: 300; letter-spacing: 1.5px; text-transform: capitalize; ">{{order.pickuppartyobject.name}}</h4>
                        </Tooltip>
                       </template>
                        <i class="fas fa-exchange card-center"></i>
                       <template v-if="order.orderDetails&&order.orderDetails.dropPoint&&order.orderDetails.dropPoint.dropPartyId">
                        <Tooltip :content="order.orderDetails.dropPoint.dropPartyName" theme="dark">
                          <h4 class="card-right" style="font-weight: 300; letter-spacing: 1.5px; text-transform: capitalize;">{{order.orderDetails.dropPoint.dropPartyName}}</h4>
                        </Tooltip>
                       </template>
                       <template v-else>
                          <Tooltip :content="order.droppingpartyobject.name" theme="dark">
                          <h4 class="card-right" style="font-weight: 300; letter-spacing: 1.5px; text-transform: capitalize;">{{order.droppingpartyobject.name}}</h4>
                        </Tooltip>
                       </template>
                      </div>
                    </Col>
                  <Divider style="margin: 2px 0 0 0;"></Divider>
                    <Col span="24">
                      <div style="font-weight: 300; padding: 0px 5px; display: flex; justify-content: space-between;">
                        <label style="font-size: 12px; color: #686e6f;">Material</label>
                        <label style="font-size: 12px; color: #686e6f;">Quantity</label>
                      </div>
                      <div style="padding: 0px 5px 5px 5px; font-weight: 300; display: flex; justify-content: space-between;">
                        <h4 class="card-left" style="font-weight: 300; width: 100%!important;">{{order.materials?order.materials.type:''}} {{order.materials?order.materials.boxes:''}} boxes</h4>
                         <h4 class="card-right" style="font-weight: 300; width: 100%!important;">{{order.materials?order.materials.kg:''}} kg</h4>
                      </div>
                    </Col>
                  <Divider style="margin: 2px 0 0 0;"></Divider>
                    <Col span="24">
                        <ApolloQuery style="padding: 5px;" :query="query_GET_ORDER_HISTORY" :variables="{orderId: order.id}">
                            <template slot-scope="{ result: { loading, error, data } }">
                                <div v-if="loading"> Loading...</div>
                                <div v-else-if="error"> Error Occured. {{error}}</div>
                                <div v-else-if="data && data.orderHistory.length" style="font-weight: 300; font-size: 12px">
                                 {{evaluateSinceDays(data.orderHistory[0].createdAt)}} Days ago
                                </div>
                                <div style="font-weight: 300; font-size: 12px" v-else>No History available</div>
                            </template>
                        </ApolloQuery>
                    </Col>
                </Row>
                </Card>
            </div>
        </kanban>
        <Drawer :mask-closable="true" class="demo-drawer-prime"
                title="Order Detail" v-model="orderDetailDrawer" width="720">
        <order-detail :orderId="orderId" ref="order-detail-page"></order-detail>
        </Drawer>
        <manage-order :orderId="orderId" ref="manage-order-page" :viewPath="viewPath"></manage-order>

    </div>
</template>

<script>
import moment from 'moment'
import Kanban from '../components/Common/Kanban'
import {GET_INTERNAL_STATUS} from '../graphql/queries/status'
import {FILTER_KANBAN_ORDERS} from '../graphql/queries/Orders'
import { SEARCH_CITY2 } from '../graphql/queries/territories'
import {GET_ORDER_HISTORY} from '../graphql/queries/orderHistory'
import OrderDetail from './OrderDetail'
import ManageOrder from './Manage Order/ManageOrder'
import {SUBSCRIBE_KANBAN_ORDERS} from '../graphql/subscription/Orders'

export default {
    apollo: {
        stages: {
            query: GET_INTERNAL_STATUS,
            result ({ data, loading }) {
                if (!loading) {
                    let self = this;
                    this.stages = [];
                    data.stages.forEach(function(curnt){    //Avoid listing of Cancel & Completed Orders in Kanban
                        if(curnt.name !== 'Completed' && curnt.name !== 'Cancel'){
                            self.stages.push(curnt)
                        }
                    })
                }
            }
        },
        orders: {
            query: FILTER_KANBAN_ORDERS,
            debounce: 500,
            subscribeToMore: {
                document: SUBSCRIBE_KANBAN_ORDERS,
                debounce: 500,
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: this.searchFilter
                    }
                },
                updateQuery: function(previousResult, { subscriptionData }) {
                    this.orders = subscriptionData.data.orders;
                },
            },
            variables() {
                return {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    clientCity: this.selectedDealerCity,
                    pickupCity: this.selectedPickupCity,
                    dropCity: this.selectedDroppingCity,
                    searchFilter: this.searchFilter
                }
            },
            result ({ data, loading }) {
                if (!loading) {
                    this.orders = data.orders;
                }
            }
        }
    },
        name: "ManageKanban",
        components: {Kanban, OrderDetail, ManageOrder},
        provide() {
            return {
                getManageOrderDrawer: () => this.manageOrderDrawer,
                setManageOrderDrawer: (data) => { this.manageOrderDrawer = data },
                getOrder: () => this.order,
                closeAssignVehicleDialog: (data) => { },
            }
        },
        data: function(){
            return{
                query_SEARCH_CITY: SEARCH_CITY2,
                query_GET_ORDER_HISTORY: GET_ORDER_HISTORY,
                stages: [],
                orders: [],
                orderDetailDrawer: false,
                orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                manageOrderDrawer: false,
                filterDate: [moment().subtract(30, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                priorityObj: {0: 'Low', 1: 'Normal', 2: 'High'},
                dealerCity: '',
                pickupCity: '',
                droppingCity: '',
                skip: {dealerSkip: true, pickupSkip: true, dropSkip: true}, //To Avoid calls at initial
                dealerCityFilter: '%%',
                pickupCityFilter: '%%',
                droppingCityFilter: '%%',
                selectedDealerCity: {"address":[]},
                selectedPickupCity: {"address":[]},
                selectedDroppingCity: {"address":[]},
                currentOrderStatus: '',
                order: '',
                viewPath: '',
                search: ''
            }
        },
        computed: {
          searchFilter () {
            return '%' + this.search + '%'
        }
        },
        methods: {
            getBlocksLength(status) {
                return this.orders.filter(block => block.internalstatus === status).length;
            },
            onChangeDate(evt){
                this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
                this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
            },
            onSearchCity(event, str){
                if(str === 'clientCity'){
                    this.dealerCityFilter = '%' + this.dealerCity + '%';
                    this.skip.dealerSkip = false;
                }else if(str === 'pickupCity'){
                    this.pickupCityFilter = '%' + this.pickupCity + '%';
                    this.skip.pickupSkip = false;
                }else if(str === 'dropCity'){
                    this.droppingCityFilter = '%' + this.droppingCity + '%';
                    this.skip.dropSkip = false;
                }
            },
            onSelectCity(city, str){
                if(str === 'clientCity'){
                  this.selectedDealerCity = {"address":[{"city": city}]};
                }else if(str === 'pickupCity'){
                  this.selectedPickupCity = {"address":[{"city": city}]};
                }else if(str === 'dropCity'){
                  this.selectedDroppingCity = {"address":[{"city": city}]};
                }
            },
            onClearCity(str){
                if(str === 'clientCity'){
                  this.selectedDealerCity = {"address":[]};
                }else if(str === 'pickupCity'){
                  this.selectedPickupCity = {"address":[]};
                }else if(str === 'dropCity'){
                  this.selectedDroppingCity = {"address":[]};
                }
            },
            evaluateSinceDays(createdAt){
                let a = moment(createdAt, 'YYYY-MM-DD');
                let b = moment(moment(), 'YYYY-MM-DD');
                return b.diff(a, 'days')
            },
            openOrderDetail(order) {
                this.orderId = order.id;
                // this.$refs['order-detail-page'].$apollo.queries.orders.skip = false;
                this.orderDetailDrawer = true;
            },
            editOrder(order){
                this.orderId = order.id;
                this.viewPath = order.internalStatus.viewPath;      //Load form based on internalStatus.viewPath
                this.order = order;
                // this.$refs['manage-order-page'].$refs['order-detail-page'].$apollo.queries.orders.skip = false;
                this.currentOrderStatus = order.internalstatus;
                this.manageOrderDrawer = true;
            },
            prevent(evt){},
        },
    mounted(){
        document.querySelector("#clientCity").setAttribute("autocomplete", "new-password");
        document.querySelector("#pickupCity").setAttribute("autocomplete", "new-password");
        document.querySelector("#dropCity").setAttribute("autocomplete", "new-password");
        }
    }

</script>

<style scoped>
 @import '../assets/kanban.css';

 /deep/ .ivu-dropdown-item{
     padding: 0px 0px;
 }
 .ivu-dropdown-item-div{
     padding: 7px 16px;
     width: 100%;
 }
  .row {
    display: flex;
  }
  .col-3{
    width: 25%
  }
  /deep/ .ivu-input{
    font-size: 14px !important;
    border-radius: 5px;
    font-size: 14px;
  }
 .filterInput{
   width: 80%;
 }
  /deep/ .ivu-date-picker-cells  {
    font-size: 12px !important;
  }
  .cardStyle{
    background: #fff !important;
    border-radius: 10px;
    box-shadow: 0px 2px 5px -3px;
    position: relative;
  }
 .cardStyle:hover{
   box-shadow: 0px 2px 7px -2px !important;
 }
 /*.cardStyle:before{*/
   /*content: '';*/
   /*width: 30px;*/
   /*height: 80px;*/
   /*background: #596363;*/
   /*position: absolute;*/
   /*right: 0px;*/
   /*top: 55px;*/
   /*z-index: 99;*/
   /*box-shadow: -3px 2px 5px -2px #686e6f;*/
 /*}*/
  .priorityLabel{
    position: absolute;
    top: 10px;
    right: 50px;

  }
  .card-left{
    letter-spacing: 1.5px;
    color: #000b15;
    width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
  }
  .card-center{
    margin-top: auto;
    text-align: center;
    margin-bottom: auto;
    width: 116px;
  }
  .card-right{
    width: 116px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: right;
    font-size: 14px;
  }
  .info{
    position: absolute;
    top: 7px;
    right: 25px;
    font-size: 16px;
    color: #596363;
  }
  .delete{
    position: absolute;
    top: 7px;
    right: 0px;
    font-size: 16px;
    color: #EB5A46;
  }

</style>
